/* Mobile drawer */
const mobileWrapper = document.querySelector('.collection-header-mobile');
const openBtn = document.querySelector('.collection-mobile-toggle');
const closeBtn = document.querySelector('.mobile-drawer-close');

openBtn?.addEventListener('click', () => {
  mobileWrapper.classList.add('is-open');
});

closeBtn?.addEventListener('click', () => {
  mobileWrapper.classList.remove('is-open');
});

mobileWrapper?.addEventListener('click', (e) => {
  if (e.target === mobileWrapper) {
    mobileWrapper.classList.remove('is-open'); 
  }
});

//

let searchActivated = false;

/* Activate search on click */
document.addEventListener('click', (e) => {
  const input = e.target.closest('.explicit-search .search-input');
  if (!input) return;

  const search = input.closest('.explicit-search');
  const submitBtn = search.querySelector('.search-submit');

  searchActivated = true;

  input.style.caretColor = 'auto';
  input.focus(); // 👈 force focus once, correctly

  if (submitBtn) {
    submitBtn.classList.add('is-active');
  }
});

/* Handle typing */
document.addEventListener('input', (e) => {
  const input = e.target.closest('.explicit-search .search-input');
  if (!input) return;

  if (!searchActivated) {
    input.value = '';
    return;
  }

  const search = input.closest('.explicit-search');
  const wrapper = search.querySelector('.predictive-search-form__content-wrapper');
  if (!wrapper) return;

  wrapper.style.display = input.value.trim().length ? 'block' : 'none';
});

/* Prevent ENTER submit */
document.addEventListener('keydown', (e) => {
  const input = e.target.closest('.explicit-search .search-input');
  if (!input) return;

  if (e.key === 'Enter') {
    e.preventDefault();
  }
});

/* Hide when clicking outside */
document.addEventListener('click', (e) => {
  document.querySelectorAll('.explicit-search').forEach((search) => {
    if (search.contains(e.target)) return;

    const wrapper = search.querySelector('.predictive-search-form__content-wrapper');
    const input = search.querySelector('.search-input');
    const submitBtn = search.querySelector('.search-submit');

    if (!wrapper || !input) return;

    wrapper.style.display = 'none';
    input.style.caretColor = 'transparent';
    searchActivated = false;

    if (submitBtn) {
      submitBtn.classList.remove('is-active');
    }
  });
});

/* Hide & reset on ESC */
document.addEventListener('keydown', (e) => {
  if (e.key !== 'Escape') return;

  document.querySelectorAll('.explicit-search').forEach((search) => {
    const wrapper = search.querySelector('.predictive-search-form__content-wrapper');
    const input = search.querySelector('.search-input');
    const submitBtn = search.querySelector('.search-submit');

    if (!wrapper || !input) return;

    wrapper.style.display = 'none';
    input.style.caretColor = 'transparent';
    searchActivated = false;

    if (submitBtn) {
      submitBtn.classList.remove('is-active');
    }
  });
});

// slider js
function desktopOnlyOwlCarousel(selector, options, breakpoint = 1024) {
  const $carousel = $(selector);

  if (!$carousel.length) return;

  function initOrDestroy() {
    if (window.innerWidth >= breakpoint) {
      if (!$carousel.hasClass('owl-loaded')) {
        $carousel.owlCarousel(options);
      }
    } else {
      if ($carousel.hasClass('owl-loaded')) {
        $carousel.trigger('destroy.owl.carousel');
        $carousel.removeClass('owl-loaded');
        $carousel.find('.owl-stage-outer').children().unwrap();
      }
    }
  }

  initOrDestroy();
  $(window).on('resize', function () {
    initOrDestroy();
  });
}

// collection circular list slider
$(document).ready(function() {
  const $bar = $('.owl-progress-bar');
    desktopOnlyOwlCarousel('.collection-circular-list__grid', {
    loop: false,
    margin: 10,
    nav: false,
    dots: false,
    responsive: {
      0:{margin: 10},
      1024: { items: 8 ,margin: 20},
      1200: { items: 10 ,margin: 20},
      1400: { items: 12 ,margin: 20},
      1600: { items: 15 ,margin: 20}
    }
  },breakpoint = 1200);

  desktopOnlyOwlCarousel('.featured-collection-slider', {
    loop: false,
    margin: 10,
    nav: false,
    dots: false,
    slideBy: 1,
    // 👇 CUSTOM HTML DEFINED HERE
    navText: [
      `
          <svg width="37px" height="18px" viewBox="0 0 1024 1024" class="icon" version="1.1" xmlns="http://www.w3.org/2000/svg" fill="#000000"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"><path d="M768 903.232l-50.432 56.768L256 512l461.568-448 50.432 56.768L364.928 512z" fill="#000000"></path></g></svg>
      `,
      `
          <svg width="40px" height="18px" viewBox="0 0 1024 1024" class="icon" version="1.1" xmlns="http://www.w3.org/2000/svg" fill="#000000"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"><path d="M256 120.768L306.432 64 768 512l-461.568 448L256 903.232 659.072 512z" fill="#000000"></path></g></svg>
      `
    ],
    responsive: {
      0:{margin: 10},
      1024: { items: 3 ,margin: 20},
      1200: { items: 5 ,margin: 20,nav:true},
      1400: { items: 5 ,margin: 20,nav:true}
    },
    onInitialized: updateScrollbarLikeProgress,
    onChanged: updateScrollbarLikeProgress,
    onResized: updateScrollbarLikeProgress,
    onRefreshed: updateScrollbarLikeProgress
  },breakpoint = 1200);


function updateScrollbarLikeProgress(e) {
  const carousel = e.relatedTarget;
  if (!carousel) return;

  const $owl = $(carousel.$element);

  // 🔥 find nearest resource list wrapper
  const $wrapper = $owl.closest('.section-resource-list');
  const $bar = $wrapper.find('.owl-progress-bar');

  if (!$bar.length) return;

  const visible = carousel.settings.items || 1;
  const total = carousel.items().length;

  const currentRel = carousel.relative(carousel.current());
  const maxRel = Math.max(0, total - visible);

  const widthPercent = Math.max((visible / total) * 100, 12);
  const travel = 100 - widthPercent;
  const leftPercent = maxRel === 0 ? 0 : (currentRel / maxRel) * travel;

  $bar.css({
    width: widthPercent + '%',
    left: leftPercent + '%'
  });
}


// const scrollbar = document.querySelector('.owl-progress');
// const thumb = scrollbar?.querySelector('.owl-progress-bar');

// if (!scrollbar || !thumb) {
//   console.warn('Custom scrollbar: missing .owl-progress or .owl-progress-bar');
// } else {
//   let activeScroller = null;
//   let raf = 0;

//   function isValidScroller(el) {
//     if (!el || el === document || el === document.documentElement || el === document.body) return false;
//     // must have actual horizontal overflow
//     return el.scrollWidth > el.clientWidth;
//   }

//   function updateScrollbar() {
//     raf = 0;
//     if (!activeScroller || !isValidScroller(activeScroller)) return;

//     const scrollWidth = activeScroller.scrollWidth;
//     const clientWidth = activeScroller.clientWidth;
//     const scrollLeft = activeScroller.scrollLeft;

//     if (scrollWidth <= clientWidth) {
//       thumb.style.width = '100%';
//       thumb.style.left = '0px';
//       return;
//     }

//     const trackWidth = scrollbar.clientWidth;

//     // thumb width (visible / total)
//     const thumbWidth = Math.max((clientWidth / scrollWidth) * trackWidth, 24);
//     thumb.style.width = thumbWidth + 'px';

//     // thumb position (end-to-end exact)
//     const maxScroll = scrollWidth - clientWidth;
//     const maxThumbMove = trackWidth - thumbWidth;

//     const left = maxScroll === 0 ? 0 : (scrollLeft / maxScroll) * maxThumbMove;
//     thumb.style.left = left + 'px';
//   }

//   function requestUpdate() {
//     if (raf) return;
//     raf = requestAnimationFrame(updateScrollbar);
//   }

//   // ✅ This captures scroll events even when scroll doesn't bubble
//   document.addEventListener(
//     'scroll',
//     (e) => {
//       const target = e.target;
//       if (isValidScroller(target)) {
//         activeScroller = target;   // <-- THIS is the real scroller
//         requestUpdate();
//       }
//     },
//     true // capture
//   );

//   // Try an initial guess: first slideshow-slides that can scroll
//   const candidates = Array.from(document.querySelectorAll('slideshow-slides'));
//   activeScroller = candidates.find(isValidScroller) || null;

//   // Initial render + keep correct on resize/load
//   window.addEventListener('resize', requestUpdate);
//   window.addEventListener('load', requestUpdate);
//   requestUpdate();
// }


(() => {
  const MQ = window.matchMedia('(max-width: 1199px)');

  document.querySelectorAll('.resource-list').forEach(resourceList => {
    const scroller =
      resourceList.querySelector('slideshow-slides');

    const scrollbar =
      resourceList.querySelector('.owl-progress');

    const thumb =
      scrollbar?.querySelector('.owl-progress-bar');

    if (!scroller || !scrollbar || !thumb) return;

    let widthLocked = false;
    let raf = 0;

    function update() {
      raf = 0;
      if (!MQ.matches) return;

      const sw = scroller.scrollWidth;
      const cw = scroller.clientWidth;
      const sl = scroller.scrollLeft;

      // no overflow
      if (sw <= cw) {
        thumb.style.width = '100%';
        thumb.style.left = '0px';
        return;
      }

      const trackW = scrollbar.clientWidth;

      // 🔒 width depends on layout only
      if (!widthLocked) {
        const w = Math.max((cw / sw) * trackW, 24);
        thumb.style.width = w + 'px';
        widthLocked = true;
      }

      const thumbW = thumb.clientWidth;
      const maxScroll = sw - cw;
      const maxMove = trackW - thumbW;

      const left =
        maxScroll === 0 ? 0 : (sl / maxScroll) * maxMove;

      thumb.style.left = left + 'px';
    }

    function requestUpdate() {
      if (raf) return;
      raf = requestAnimationFrame(update);
    }

    // 🔹 ONLY listen to THIS slider
    scroller.addEventListener('scroll', requestUpdate, {
      passive: true
    });

    // 🔹 reset width on layout changes
    window.addEventListener('resize', () => {
      widthLocked = false;
      requestUpdate();
    });

    window.addEventListener('load', () => {
      widthLocked = false;
      requestUpdate();
    });

    // 🔹 watch internal size changes (images, responsive)
    const ro = new ResizeObserver(() => {
      widthLocked = false;
      requestUpdate();
    });
    ro.observe(scroller);
    ro.observe(scrollbar);

    // initial render
    requestUpdate();
  });
})();




});




  document.querySelectorAll('.section-content-wrapper').forEach(section => {
    const acc = section.querySelector('.accordion');
    if (acc && !acc.querySelector('*')) {
      section.style.display = 'none';
    }
  });

  



// Start Recomanded Progress Slider JS
document.addEventListener('DOMContentLoaded', () => {
  const observer = new MutationObserver(() => {
    const parent = document.querySelector('.product-recommendations');
    if (!parent) return;

    const slider = parent.querySelector('.resource-list');
    const items = slider?.querySelectorAll('.resource-list__item') || [];

    if (slider && items.length) {
      initSlider(slider, items.length);
      observer.disconnect();
    }
  });

  observer.observe(document.body, { childList: true, subtree: true });
});

function initSlider(slider, totalItems) {
  if (slider.dataset.init === 'true') return;
  slider.dataset.init = 'true';

  const gap = 20;
  const items = slider.querySelectorAll('.resource-list__item');

  /* BASIC */
  slider.style.display = 'flex';
  slider.style.gap = gap + 'px';
  slider.style.overflowX = 'auto';
  slider.style.scrollBehavior = 'auto';
  slider.style.paddingBottom = '16px';

  /* WRAPPER */
  const wrapper = document.createElement('div');
  wrapper.className = 'resource-list-wrapper';
  slider.parentNode.insertBefore(wrapper, slider);
  wrapper.appendChild(slider);

  /* BUTTONS */
  const btnWrap = document.createElement('div');
  btnWrap.className = 'slider-buttons';

 const prevBtn = document.createElement('button');
const nextBtn = document.createElement('button');

prevBtn.className = 'slider-prev';
nextBtn.className = 'slider-next';

prevBtn.innerHTML = `
<svg width="37px" height="18px" viewBox="0 0 1024 1024"
  xmlns="http://www.w3.org/2000/svg" fill="currentColor">
  <path d="M768 903.232l-50.432 56.768L256 512l461.568-448
           50.432 56.768L364.928 512z"/>
</svg>
`;

nextBtn.innerHTML = `
<svg width="40px" height="18px" viewBox="0 0 1024 1024"
  xmlns="http://www.w3.org/2000/svg" fill="currentColor">
  <path d="M256 120.768L306.432 64 768 512l-461.568 448
           L256 903.232 659.072 512z"/>
</svg>
`;


  btnWrap.append(prevBtn, nextBtn);
  wrapper.appendChild(btnWrap);

  /* PROGRESS */
  const progress = document.createElement('div');
  progress.className = 'slider-progress';
  const bar = document.createElement('span');
  progress.appendChild(bar);
  wrapper.appendChild(progress);

  /* CALC */
  const step = items[0].offsetWidth + gap;
  const visibleCount = Math.round(slider.clientWidth / step);
  const maxIndex = Math.max(0, totalItems - visibleCount);

  /* PROGRESS UPDATE */
  const updateProgress = () => {
    const track = progress.clientWidth || 1;
    const fill = (visibleCount / totalItems) * track;
    const maxMove = track - fill;

    const ratio =
      maxIndex === 0 ? 0 : slider.scrollLeft / (maxIndex * step);

    bar.style.width = fill + 'px';
    bar.style.transform = `translateX(${ratio * maxMove}px)`;

    prevBtn.disabled = slider.scrollLeft <= 1;
    nextBtn.disabled = slider.scrollLeft >= maxIndex * step - 1;

    prevBtn.style.opacity = prevBtn.disabled ? '0.4' : '1';
    nextBtn.style.opacity = nextBtn.disabled ? '0.4' : '1';
  };

  slider.addEventListener('scroll', updateProgress);

  /* BUTTON ACTION */
  prevBtn.addEventListener('click', () => {
    const i = Math.round(slider.scrollLeft / step);
    slider.scrollTo({ left: Math.max(0, i - 1) * step, behavior: 'smooth' });
  });

  nextBtn.addEventListener('click', () => {
    const i = Math.round(slider.scrollLeft / step);
    slider.scrollTo({
      left: Math.min(maxIndex, i + 1) * step,
      behavior: 'smooth'
    });
  });

  /* ================================
     MOUSE DRAG (SMOOTH + SAFE)
  ================================= */
  let isDown = false;
  let startX = 0;
  let lastX = 0;
  let velocity = 0;
  let rafId = null;
  let isDraggingMoved = false;
  const DRAG_THRESHOLD = 6; // px

  slider.addEventListener('mousedown', e => {
    if (e.button !== 0) return;
    isDown = true;
    isDraggingMoved = false;
    startX = lastX = e.pageX;
    velocity = 0;
    slider.classList.add('is-dragging');
    cancelAnimationFrame(rafId);
  });

  document.addEventListener('mousemove', e => {
    if (!isDown) return;

    const dx = e.pageX - lastX;
    lastX = e.pageX;

    if (Math.abs(e.pageX - startX) > DRAG_THRESHOLD) {
      isDraggingMoved = true;
    }

    velocity = dx * 0.8;
    slider.scrollLeft -= dx;
  });

  document.addEventListener('mouseup', () => {
    if (!isDown) return;
    isDown = false;
    slider.classList.remove('is-dragging');

    /* inertia */
    const momentum = () => {
      if (Math.abs(velocity) < 0.5) {
        snap();
        return;
      }
      slider.scrollLeft -= velocity;
      velocity *= 0.95;
      rafId = requestAnimationFrame(momentum);
    };
    momentum();
  });

  /* SNAP */
  const snap = () => {
    const index = Math.round(slider.scrollLeft / step);
    slider.scrollTo({
      left: Math.min(index, maxIndex) * step,
      behavior: 'smooth'
    });
  };

  /* 🚫 CLICK CANCEL AFTER DRAG (KEY FIX) */
  slider.addEventListener(
    'click',
    e => {
      if (isDraggingMoved) {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        isDraggingMoved = false;
      }
    },
    true // capturing phase
  );

  /* INIT */
  updateProgress();
}

// End Recomanded Progress Slider JS


// Start Product Page Media slider Smoothness 
document.addEventListener('click', function (e) {
  const thumb = e.target.closest('.slideshow-controls__thumbnail');
  if (!thumb) return;

  const slides = thumb
    .closest('media-gallery')
    ?.querySelector('slideshow-slides');

  if (!slides) return;

  // ⛔ Disable smooth temporarily
  slides.style.scrollBehavior = 'auto';

  // ✅ Restore smooth after jump
  requestAnimationFrame(() => {
    requestAnimationFrame(() => {
      slides.style.scrollBehavior = 'smooth';
    });
  });
});

// End Product Page Media slider Smoothness 

// Start Product Page Media slider Next and Prev Disable
(function () {
  function updateSlideshowArrows(slideshow) {
    if (!slideshow) return;

    const slides = slideshow.querySelectorAll('slideshow-slide:not([hidden])');
    if (!slides.length) return;

    const prevBtn = slideshow.querySelector('.slideshow-control--previous');
    const nextBtn = slideshow.querySelector('.slideshow-control--next');

    // current slide = aria-hidden="false"
    const currentIndex = [...slides].findIndex(
      slide => slide.getAttribute('aria-hidden') === 'false'
    );

    if (prevBtn) {
      prevBtn.disabled = currentIndex <= 0;
    }

    if (nextBtn) {
      nextBtn.disabled = currentIndex >= slides.length - 1;
    }
  }

  // Initial load
  document.querySelectorAll('slideshow-component').forEach(updateSlideshowArrows);

  // Listen to slideshow change events
  document.addEventListener('slideshow:select', function (e) {
    const slideshow = e.target.closest('slideshow-component');
    updateSlideshowArrows(slideshow);
  });

  // Also handle scroll / drag changes (fallback safety)
  document.addEventListener('scroll', function () {
    document.querySelectorAll('slideshow-component').forEach(updateSlideshowArrows);
  }, true);
})();
// End Product Page Media slider Next and Prev Disable




// Start Mega Menu JS
document.addEventListener("DOMContentLoaded", function () {

  function initMegaMenus() {

    const menuItems = document.querySelectorAll(".custom-menu-list-item");
    if (!menuItems.length) return;

    menuItems.forEach(menuItem => {

      if (menuItem.dataset.megaInitialized === "true") return;
      menuItem.dataset.megaInitialized = "true";

      const submenuLinks = menuItem.querySelectorAll(".mega-menu__column > div > a");
      const panels = menuItem.querySelectorAll(".mega-products-panel");
      if (!panels.length) return;

      const parentLink = menuItem.querySelector(".menu-list__link");
      if (!parentLink) return;

      let parentHandle = null;

      if (parentLink.getAttribute("href")?.includes("/collections/")) {
        parentHandle = parentLink.getAttribute("href").split("/collections/")[1];
      }

      const defaultPanel = menuItem.querySelector(".mega-products-panel.default-panel");

      let parentLocked = false;

      if (defaultPanel && parentHandle) {
        const panelHandle = defaultPanel.getAttribute("data-handle");
        if (panelHandle === parentHandle) {
          parentLocked = true;
        }
      }

      function activatePanel(targetPanel, link = null) {

        if (!targetPanel) return;
        if (targetPanel.classList.contains("active")) return;

        panels.forEach(panel => panel.classList.remove("active"));
        submenuLinks.forEach(l => l.classList.remove("active"));

        requestAnimationFrame(() => {
          targetPanel.classList.add("active");
          if (link) link.classList.add("active");
        });
      }

      function activateByLink(link) {

        if (!link) return;

        const href = link.getAttribute("href");
        if (!href) return;

        const handle = href.split("/").pop();

        const targetPanel = menuItem.querySelector(
          '.mega-products-panel[data-handle="' + handle + '"]'
        );

        activatePanel(targetPanel, link);
      }

      // Default Activation
      if (!menuItem.querySelector(".mega-products-panel.active")) {

        if (parentLocked) {
          activatePanel(defaultPanel);
        } else if (submenuLinks.length) {
          activateByLink(submenuLinks[0]);
        }
      }

      // Hover Switching ONLY if parent not locked
      if (!parentLocked) {
        submenuLinks.forEach(link => {
          link.addEventListener("mouseenter", function () {
            activateByLink(this);
          });
        });
      }

    });
  }

  const observer = new MutationObserver(() => {
    if (document.querySelector(".mega-products-panel")) {
      initMegaMenus();
    }
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

  initMegaMenus();

});


// End Mega Menu JS


// Start Mobile Menu Reset State
document.addEventListener('DOMContentLoaded', function () {

  // Select the mobile menu container
  const mobileMenu = document.querySelector('.custom-mobile-menu');

  // If mobile menu does not exist, stop execution
  if (!mobileMenu) return;

  mobileMenu.addEventListener('toggle', function (e) {

    const toggledDetails = e.target;

    // Only proceed if the toggled element is a <details> tag
    if (toggledDetails.tagName !== 'DETAILS') return;

    // If the current <details> is being closed
    if (!toggledDetails.open) {

      // Find all nested <details> inside it and close them
      toggledDetails.querySelectorAll('details').forEach(innerDetail => {
        innerDetail.open = false;
      });

    }

  }, true);

  // Select the close button inside mobile menu
  const closeBtn = mobileMenu.querySelector('.menu-drawer__close-button');

  if (closeBtn) {
    closeBtn.addEventListener('click', function () {

      // Close all <details> elements inside the mobile menu
      mobileMenu.querySelectorAll('details').forEach(detail => {
        detail.open = false;
      });

    });
  }

});

// End  Mobile Menu Reset State


// Start Sticky Quantity Sync with Main

document.addEventListener("DOMContentLoaded", function () {
function getMainQtyInput() {
    return document.querySelector(
      'form[action^="/cart/add"] quantity-selector-component input[name="quantity"]'
    );
  }

  function getStickyQtyInput() {
    return document.querySelector(
      '.custom-sticky-cart-main quantity-selector-component input[name="quantity"]'
    );
  }

  function syncValues(source, target) {
    if (!source || !target) return;

    const value = source.value;
    target.value = value;

    target.dispatchEvent(new Event("input", { bubbles: true }));
    target.dispatchEvent(new Event("change", { bubbles: true }));
    target.dispatchEvent(new Event("blur", { bubbles: true }));
  }

  function attachQuantitySync() {
    const mainInput = getMainQtyInput();
    const stickyInput = getStickyQtyInput();

    if (!mainInput || !stickyInput) return;

    mainInput.addEventListener("input", function () {
      syncValues(mainInput, stickyInput);
    });

    stickyInput.addEventListener("input", function () {
      syncValues(stickyInput, mainInput);
    });

    const mainComponent = mainInput.closest("quantity-selector-component");
    const stickyComponent = stickyInput.closest("quantity-selector-component");

    if (mainComponent) {
      mainComponent.addEventListener("click", function () {
        setTimeout(() => syncValues(mainInput, stickyInput), 60);
      });
    }

    if (stickyComponent) {
      stickyComponent.addEventListener("click", function () {
        setTimeout(() => syncValues(stickyInput, mainInput), 60);
      });
    }
  }
  attachQuantitySync();
  document.addEventListener("variant:change", function () {
    setTimeout(attachQuantitySync, 200);
  });

  function observeStickyButton() {

    const stickyButton = document.querySelector(
      ".custom-sticky-cart-main .sticky-add-to-cart__button"
    );

    if (!stickyButton) return;

    const observer = new MutationObserver(function (mutations) {

      mutations.forEach(function (mutation) {

        if (
          mutation.type === "attributes" &&
          mutation.attributeName === "data-added" &&
          stickyButton.getAttribute("data-added") === "true"
        ) {
          setTimeout(() => {

            stickyButton.setAttribute("data-added", "false");
            void stickyButton.offsetWidth;

          }, 2500);
        }
      });

    });

    observer.observe(stickyButton, { attributes: true });
  }
  observeStickyButton();
const bodyObserver = new MutationObserver(function () {
    observeStickyButton();
  });
  bodyObserver.observe(document.body, {
    childList: true,
    subtree: true
  });
});
// End  Sticky Quantity Sync with Main

// Start Numerology Complete Report Product Datepicker Click Anywhere
document.addEventListener("DOMContentLoaded", function() {
  const dobInput = document.getElementById("dob");

  if (dobInput && dobInput.showPicker) {
    dobInput.addEventListener("click", function() {
      this.showPicker();
    });

    dobInput.addEventListener("focus", function() {
      this.showPicker();
    });
  }
});

// End Numerology Complete Report Product Datepicker Click Anywhere


// Start Disable Buy Button Numerology Complete Report Product
document.addEventListener("DOMContentLoaded", function () {

  const formWrapper = document.querySelector(".addtional-info-custom-form");
  if (!formWrapper) return;

  const requiredFields = formWrapper.querySelectorAll("[required]");

  function validateForm() {
    const buyBtn = document.querySelector('#MainContent[data-template="product.numerology-report-product"] .shopify-payment-button__button');
    if (!buyBtn) return;

    let valid = true;

    requiredFields.forEach(field => {
      if (!field.value.trim()) valid = false;
    });

    if (!valid) {
      buyBtn.setAttribute("disabled", "disabled");
      buyBtn.style.cursor = "not-allowed";
      buyBtn.style.opacity = "0.6";
    } else {
      buyBtn.removeAttribute("disabled");
      buyBtn.style.cursor = "pointer";
      buyBtn.style.opacity = "1";
    }
  }

  // Shopify dynamic re-render handle
  const observer = new MutationObserver(validateForm);
  observer.observe(document.body, { childList: true, subtree: true });

  requiredFields.forEach(field => {
    field.addEventListener("input", validateForm);
    field.addEventListener("change", validateForm);
  });

  validateForm();

});

// Start Disable Buy Button Numerology Complete Report Product

document.querySelectorAll("p").forEach(p => {
  if (p.innerHTML.trim() === "&nbsp;" || p.textContent.trim() === "") {
    p.style.display = "none";
  }
});